import { render, staticRenderFns } from "./LocalizedComponent.vue?vue&type=template&id=4054a654&scoped=true"
import script from "./LocalizedComponent.vue?vue&type=script&lang=js"
export * from "./LocalizedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054a654",
  null
  
)

export default component.exports